<template>
  <div class="client-login screen-first" >
    <div class="login-type">
      <div class="select-box">
        <div
          v-for="(item, index) in loginSections"
          :key="index"
          class="select-item"
          :style="{ background: loginType === item.loginType ? '#22c8cc' : ''}"
          @click="switchLogin(item.loginType, index)"
        >
          <!-- <img :src="loginType === item.loginType  ? item.activeIcon : item.icon" /> -->
          <i :class="{ 'active-item': loginType === item.loginType}"></i>
          <span >{{ item.title }}</span>
        </div>
      </div>
      <div class="show-box">
        <transition name="fade" mode="out-in">
          <router-view />
        </transition>
      </div>
    </div>

    <!-- <p class="login-copyright" v-if="isRegister== 0 || isAgree ||(isRegister== 0&& !isAgree) "> -->
    <p class="login-copyright" v-if="isRegister== 0 || isAgree">
    <!-- <p class="login-copyright" > -->
      <i :class="{'check-icon': isAgree }" @click="useAgree" v-if="isRegister== 0 || isAgree"></i>
      <!-- <i :class="{'check-icon': isAgree }" @click="useAgree" ></i> -->
      <span>我已经阅读并同意&nbsp;&nbsp;</span>
      <span @click="useAgreeModal">《云游戏用户协议》</span>及<span @click="useAgreeModal" style="cursor:pointer" class="enterAgreement">《隐私声明》</span>
    </p>
    <!-- 用户协议-->
    <Dialog
      v-if="agreeDialog"
      custom-class="choose-agree-dialog"
      :show.sync="agreeDialog"
      top="30px"
      width="1100px"
     
    >
      <useAgree  @close='agreeDialog =false' />
      <div class="footer" style="margin-top:50px">
        <!-- <Button @click="submitShortOrderInfo">确定</Button> -->
        <span @click="agreeDialog=false">不同意</span>
        <span @click="agree()">已阅读并同意</span>
      </div>
    </Dialog>
    <!-- qq登录 -->
    <!-- <qqLogin v-if="loginType==3"/> -->
    <!-- <Dialog v-if="qqloginVisible" custom-class="choose-agree-dialog" :show.sync="qqloginVisible" width='450px' top='80px'>
      <qqLogin/>
     
    </Dialog>-->
  </div>
</template>

<script>
import useAgree from "views/Settings/userAgree";
import qqLogin from "./components/qq";
export default {
  name: "Login",
  components: {
    useAgree,
    qqLogin
  },
  data() {
    return {
      loginType: 1,
      loginSections: [
        // 登录类型选择
        {
          title: "手机登录",
          loginType: 1
        },
        {
          title: "微信登录",
          loginType: 2
        },
        {
          title: "QQ登录",
          loginType: 3
        }
      ],
      /* 登录方式的映射关系 */
      mapLoginType: {
        "/qqlogin": 3,
        "/login_wechat": 2,
        "/mobile": 1,
        3: "/qqlogin",
        2: "/login_wechat",
        1: "/mobile"
      },
      isAgree: false,
      agreeDialog: false,
      qqloginVisible: false
    };
  },
  methods: {
    switchLogin(type, index) {
      this.loginType = type;
      this.$router.push(this.mapLoginType[type]);
      // if(type === 3){
      //   this.qqloginVisible = true

      // }else{
      //   this.$router.push(this.mapLoginType[type]);
      // }
      // this.$router.push('/home');
    },
    /* 用户协议选择 */
    useAgree() {
      this.isAgree = !this.isAgree;
      if (this.isAgree) this.$store.commit("setAgree", 1);
    },
    /* 用户协议 */
    useAgreeModal() {
      this.agreeDialog = true;
      // this.$router.push("/userAgree");
    },
    async checkRegister() {
      // const res = this.$http.validate_mobile()
    },
    agree() {
      this.isAgree = true;
      this.agreeDialog = false;
      this.$store.commit("setAgree", 1);
    }
  },
  computed: {
    isRegister() {
      // if()
      if (this.$store.state.isRegister == 0) {
        this.agreeDialog = true;
      }
      return this.$store.state.isRegister;
    }
  },
  watch: {
    isRegister: {
      handler(val, oldVal) {},
      deep: true
    }
  },
  mounted() {
    this.loginType = this.mapLoginType[this.$route.path];
    this.$nextTick(() =>{
        screenFirst();
      })
  }
};
</script>

<style lang="scss" >
.client-login {
  overflow: hidden;
  // background-image: url(/img/body_bg.jpg);
  // width: 100%;
  // height: 100%;
  // margin-top: -80px;
  // background-size: 100% 100%;
  
  background-image: url(~assets/img/body_bg.jpg);
  width: 100%;
  // height: 100%;
  margin-top: -80px;
  background-size: 100% 100%;
  * {
    color: rgba(221, 221, 221, 1);
  }
  .login-type {
    
    padding: 0 165px;
    padding-top: 229px;
    color: #ffffff;
    margin: auto;
    margin-top: 70px;

    margin-bottom: 15px;
    /* background: rgba(7,12,21,.5); */
    width: 942px;
    display: flex;
    // justify-content: space-between;
    .select-box {
      // @include size(162px, 100%);
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .select-item {
        cursor: pointer;
        margin: 0 20px 20px 0;
        padding: 35px 40px;
        background: rgba(7, 12, 21, 0.5);
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        &:hover {
          background: #22c8cc;
        }
        i {
          display: inline-block;
          @include size(46px, 46px);
          margin-right: 7px;
        }
        .active-item {
          background: #22c8cc;
        }

        &:nth-of-type(1) {
          i {
            background: url("~assets/img/phone.png") no-repeat;
          }
        }

        &:nth-of-type(2) {
          i {
            background: url("~assets/img/weixin.png") no-repeat;
          }
        }
        &:nth-of-type(3) {
          i {
            background: url("~assets/img/qq.png") no-repeat;
          }
        }
        span {
          margin-left: 20px;
          font-size: 18px;
        }
      }
    }
  }
  .show-box {
    position: relative;
    @include size(660px, 388px);
    // margin: 20px 20px 20px 0;
    border-radius: 5px;
    background: rgba(7, 12, 21, 0.5);
    .login-mobile {
      text-align: center;
      width: 306px;
      margin: 0 auto;
      .card-login-bottom {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        font-size: 16px;
        width: 300px;
        margin-top: 10px;
        span {
          cursor: pointer;
          color: #b7b7b7  ;
          &:hover {
            cursor: pointer;
            color: #65dfec;
          }
        }
      }
    }
  }
  .login-copyright {
    font-size: 18px;
    text-align: center;
    i {
      display: inline-block;
      @include size(27px, 27px);
      background: url("~assets/img/untick.png") no-repeat;
      vertical-align: middle;
      margin-right: 5px;
      cursor: pointer;
      margin-top: -5px;
      &.check-icon {
        background: url("~assets/img/ticked.png") no-repeat;
      }
    }

    span {
      font-size: 18px;
      &:nth-of-type(2) {
        cursor: pointer;
      }
    }
  }
  .login-mobile {
    * {
      color: #fff;
      
    }
    
    text-align: center;
    margin: 0 auto;
    
    display: flex;
    flex-direction: column;
    .login-title {
      padding: 40px 0 18px 0;
      font-size: 22px;
      font-weight: 500;
      color: #fff;
      text-align: center;
    }
    .el-input .el-input__inner,
    .el-button {
      border-radius: 30px !important;
    }
    .el-input__inner {
      background: rgba(0, 0, 0, 0.2);
      color: #ddd;
      border-color: #5c5c5c;
      height: 43px;
      line-height: 43px;
    }
    .el-button {
      background: #36e1e5;
      border-color: #36e1e5;
      color: #fff;
      height: 43px;
      font-size: 18px;
      text-align: center;
      span{
         color: #fff;
      }
      // line-height: 43px;
    }
    .el-form-item{
      margin-bottom: 31px;
    }
    .el-form-item__error {
      color: #ff3b00;
    }
    .el-form-item.is-error .el-input__inner,
    .el-form-item.is-error .el-input__inner:focus,
    .el-form-item.is-error .el-textarea__inner,
    .el-form-item.is-error .el-textarea__inner:focus,
    .el-message-box__input input.invalid,
    .el-message-box__input input.invalid:focus {
      border-color: #ff3b00;
    }
    
    .sms-btn {
      font-size: 14px;
      width: 108px;
      background: transparent;
      span{
        color:#36e1e5 ;
      }
      // &:hover {
      //   background: rgba(170, 217, 249, 0.3);
      // }
    }
    .save-pwd-btn {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      width: 76px;
      height: 41px;
      padding: 0 15px;
      border-radius: 30px;
      line-height: 43px;
      // background: rgba(170, 217, 249, 0.2);
      border:1px solid #36e1e5 !important;
      cursor: pointer;
    }
  }
}
.choose-agree-dialog {
  .footer {
    padding-bottom: 20px;
    text-align: center;
    span {
      display: inline-block;
      @include size(170px, 45px);
      line-height: 45px;
      border-radius: 28px;
      font-size: 16px;
      margin: 0 35px;
      text-align: center;
      cursor: pointer;
      background: #31abda;
    }
  }
}
.show-box{
  .step-bar{
    margin: 0 auto;
    margin-top:20px;
  }
}

</style>




